import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./css/normalize.css";
import "./css/dropzone.css";

import App from "js/App/App.container";
import { Provider } from "react-redux";
import crearStore from "js/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { socialIdClients } from "./js/constants";

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: socialIdClients.microsoft,
    authority: "https://login.microsoftonline.com/consumers",
    redirectUri: window.location.origin
  }
});

const url = window.location.hostname.replace("www.", "");

ReactDOM.createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={socialIdClients.google}>
    <MsalProvider instance={msalInstance}>
      <Provider store={crearStore(url)}>
        <App />
      </Provider>
    </MsalProvider>
  </GoogleOAuthProvider>
);
